import classNames from "classnames";
import React, { useEffect, useState } from "react";
import mic from "../../../assets/images/editor/mic.svg";
import mute_mic from "../../../assets/images/editor/mute-mic.svg";
import SpeechRecognition, {
  useSpeechRecognition
} from "react-speech-recognition";

const SpeechToTextSmallButton = ({ copyWordToEditor }) => {
  const [listener, setListener] = useState(false);
  const [previousWord, setreviousWord] = useState(null);

  const {
    transcript,
    listening,
    browserSupportsSpeechRecognition,
    browserSupportsContinuousListening,
    isMicrophoneAvailable,
    resetTranscript
  } = useSpeechRecognition();

  const turnListening = () => {
    if (!listening) {
      resetTranscript();
      setreviousWord(null);
      SpeechRecognition.startListening({ language: "es-AR", continuous: true });
    } else {
      SpeechRecognition.stopListening();
    }
  };

  if (
    !browserSupportsSpeechRecognition ||
    !browserSupportsContinuousListening
  ) {
    return null;
  }

  useEffect(() => {
    if (listening) {
      if (transcript) {
        const arrayOfWords = transcript.split(" ");
        const wordToCopy = arrayOfWords.pop();
        if (wordToCopy) {
          if (arrayOfWords.length === 1) {
            copyWordToEditor(wordToCopy);
            setreviousWord(wordToCopy);
          }

          if (
            previousWord &&
            wordToCopy.toLowerCase().startsWith(previousWord.toLowerCase())
          ) {
            const fixedWord = wordToCopy.replace(previousWord, "");
            copyWordToEditor(fixedWord);
            setreviousWord(previousWord + fixedWord);
          } else {
            copyWordToEditor(" " + wordToCopy);
            setreviousWord(wordToCopy);
          }
        }
      }
      delayStopListening();
    }
    return () => {};
  }, [transcript, listening]);

  const delayStopListening = () => {
    clearTimeout(listener);
    setListener(
      setTimeout(() => {
        setreviousWord(null);
        SpeechRecognition.stopListening();
      }, 3000)
    );
  };

  return (
    <div className="rdw-colorpicker-wrapper">
      <div
        className={classNames("rdw-option-wrapper", "", {
          [`default-option-active recording ${
            listening ? "pulsating" : ""
          }`]: listening,
          "default-option-disabled": !isMicrophoneAvailable
        })}
        onClick={() => {
          turnListening();
        }}
        aria-selected={listening}
        title={"Escribir con voz"}
      >
        <img
          /* style={collpased ? imageCollapsedStyle : imageDefaultStyle} */ src={
            listening ? mute_mic : mic
          }
          width={"15px"}
          height={"15px"}
          alt=""
        />
      </div>
    </div>
  );
};

export default SpeechToTextSmallButton;
